import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import axios from 'axios';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Header from '../boarddetail/components/Header';
import Footer from 'examples/Footer';
import { apiRegisterNotice, apiFileUpload } from '../../../api/notice.api';
import {useData} from '../../../hooks';
import TopNavbar from 'examples/Navbars/TopNavbar';

const BoardInsert = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    messageType: '',
    subType: '',
    orderno: '',
  });
  const [file, setFile] = useState(null);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [previewImage, setPreviewImage] = useState(null);
  const {user, appIsReady} = useData();

  useEffect(() => {
    setLoading(false);
  }, []);

  const messageTypeToString = (type) => {
    switch (type) {
      case 1: return '앱공지';
      case 3: return '매뉴얼';
      case 4: return '점주용공지';
      case 5: return '점주용매뉴얼';
      case 6: return '후원사';
      default: return '기타';
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSave = async () => {
    const filteredFormData = { ...formData };

    if (formData.messageType !== 3 && formData.messageType !== 5 && formData.messageType !== 6) {
      delete filteredFormData.subType;
      delete filteredFormData.orderno;
    }

    try {
      await apiRegisterNotice(filteredFormData, user.accessToken);
      navigate(`/boards`, { state: { messageType: formData.messageType } });
    } catch (error) {
      console.error('Error registering notice:', error);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) {
      return;
    }
    setFile(selectedFile);
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewImage(reader.result);
    };
    reader.readAsDataURL(selectedFile);
  };


  const handleUpload = async () => {
    if (!file) return;

    const uploadFormData = new FormData();
    uploadFormData.append('file', file);

    try {
      const response = await apiFileUpload(uploadFormData, user.accessToken);
      console.log("response=" + response);
      const imageUrl = response;
      setUploadedImages([...uploadedImages, imageUrl]);
      if(formData.messageType === 5){
        setFormData({
          ...formData,
          content: `${imageUrl}`
        });
      }else{
        setFormData({
          ...formData,
          content: `${formData.content}\n<img src="${imageUrl}" width="100%">\n`
        });
      }
      setFile(null); // Clear the file input
      setPreviewImage(null); // Clear the preview image
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };

  if (loading) {
    return (
      <DashboardLayout>
        <TopNavbar />
        <Header />
        <MDBox pt={6} pb={3}>
          <MDTypography variant="h4" color="info">
            Loading...
          </MDTypography>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  const showSubTypeAndOrderno = formData.messageType === 3 || formData.messageType === 5 || formData.messageType === 6;

  return (
    <DashboardLayout>
      <TopNavbar />
      <Header>
        <MDBox pt={6} pb={3}>
          <MDBox mb={2} display="flex" justifyContent="space-between">
            <MDTypography variant="h4" fontWeight="bold">
              공지 등록
            </MDTypography>
            <Button variant="contained" color="success" onClick={handleSave}>
              저장
            </Button>
          </MDBox>
          <MDBox mb={2} padding={1.5} borderRadius={10}>
            <FormControl fullWidth variant="outlined">
              <InputLabel>메시지 타입</InputLabel>
              <Select
                label="메시지 타입"
                name="messageType"
                value={formData.messageType}
                onChange={handleChange}
                sx= {{
                  height: 45, width: 150
                }}
                IconComponent={ArrowDropDownIcon}
              >
                <MenuItem value={1}>앱공지</MenuItem>
                <MenuItem value={3}>매뉴얼</MenuItem>
                <MenuItem value={4}>점주용공지</MenuItem>
                <MenuItem value={5}>점주용매뉴얼</MenuItem>
                <MenuItem value={6}>후원사</MenuItem>
              </Select>
            </FormControl>
            <TextField
              fullWidth
              label="제목"
              name="title"
              value={formData.title}
              onChange={handleChange}
              variant="outlined"
              margin="normal"
            />
            <TextField
              fullWidth
              label="내용"
              name="content"
              value={formData.content}
              onChange={handleChange}
              variant="outlined"
              margin="normal"
              multiline
              rows={15}
            />
            {showSubTypeAndOrderno && (
              <>
                <TextField
                  fullWidth
                  label="서브 타입"
                  name="subType"
                  value={formData.subType}
                  onChange={handleChange}
                  variant="outlined"
                  margin="normal"
                />
                <TextField
                  fullWidth
                  label="순서"
                  name="orderno"
                  value={formData.orderno}
                  onChange={handleChange}
                  variant="outlined"
                  margin="normal"
                />
              </>
            )}
          </MDBox>
          <MDBox mt={2} display="flex" alignItems="center">
            <input
              accept="image/*"
              style={{ display: 'none' }}
              id="contained-button-file"
              type="file"
              onChange={handleFileChange}
            />
            <label htmlFor="contained-button-file">
              <Button variant="contained" component="span" color="info">
                파일 선택
              </Button>
            </label>
            <Button variant="contained" color="success" onClick={handleUpload} sx={{ marginLeft: 2 }}>
              업로드
            </Button>
          </MDBox>
          <MDBox mt={2}>
            {previewImage && (
              <img src={previewImage} alt="preview" style={{ width: '20%', marginBottom: 10 }} />
            )}
            {uploadedImages.map((url, index) => (
              <img key={index} src={url} alt={`uploaded ${index}`} style={{ width: '20%', marginBottom: 10 }} />
            ))}
          </MDBox>
          <MDBox mt={2}>
            <Button variant="contained" color="success" onClick={() => navigate(-1)}>
              뒤로 가기
            </Button>
          </MDBox>
        </MDBox>
      </Header>
      <Footer />
    </DashboardLayout>
  );
}

export default BoardInsert;
